import { render, staticRenderFns } from "./fund-side-risk-warning-panel.vue?vue&type=template&id=217165fa&"
var script = {}
import style0 from "./fund-side-risk-warning-panel.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports